// extracted by mini-css-extract-plugin
export default {"search-container":"SearchBar_search-container__2KvMZ","search-input":"SearchBar_search-input__zBoHD","search-boton":"SearchBar_search-boton__v6QhU"};